//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PlasmaOsmoticPressure',
  data () {
    return {
      defaultJson: {
        'Na': 'Na',
        'K': 'K',
        'Glucose': '血糖',
        'BUN': '尿素氮',
      },
      form: {
        na: '',
        k: '',
        glucose: '',
        bun: ''
      },
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        console.log(form)
        // 血浆渗透压（mOsm/kg）= 2（Na+ + K+）+ 尿素氮 + 血糖（单位均为 mmol/L）
        let result = 2 * (form.na + form.k) + form.glucose + form.bun
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/PlasmaOsmoticPressure.vue